import { useEffect, useState } from 'react';
import {
    AktivSakStatus,
    DineSkiltSakStatus,
    PersonligKjennemerkeStatuser,
} from '../utils/api';

export const useSoknad = (soknader?: PersonligKjennemerkeStatuser) => {
    const [aktiveSoknader, setAktiveSoknader] = useState<
        PersonligKjennemerkeStatuser | []
    >([]);
    const [dineSkiltSoknader, setDineSkiltSoknader] = useState<
        PersonligKjennemerkeStatuser | []
    >([]);

    useEffect(() => {
        if (soknader) {
            setAktiveSoknader(
                soknader.filter((soknad) =>
                    Object.keys(AktivSakStatus).find(
                        (status) => status === soknad.sakStatus,
                    ),
                ),
            );
            setDineSkiltSoknader(
                soknader.filter((soknad) =>
                    Object.keys(DineSkiltSakStatus).find(
                        (status) => status === soknad.sakStatus,
                    ),
                ),
            );
        }
    }, [soknader]);

    return { aktiveSoknader, dineSkiltSoknader };
};
